import * as React from "react"

export class PlaceholderBtn extends React.PureComponent<{}, {}>{
    render() {
        return (
            <>
                <div className="rj-ev-list__placeholder__card-buttons">
                    <div className="rj-ev-list__placeholder__card-buttons-text"></div>
                    <div className="rj-ev-list__placeholder__card-buttons-odd"></div>
                </div>
                <div className="rj-ev-list__placeholder__card-buttons">
                    <div className="rj-ev-list__placeholder__card-buttons-text"></div>
                    <div className="rj-ev-list__placeholder__card-buttons-odd"></div>
                </div>
                <div className="rj-ev-list__placeholder__card-buttons">
                    <div className="rj-ev-list__placeholder__card-buttons-text"></div>
                    <div className="rj-ev-list__placeholder__card-buttons-odd"></div>
                </div>
                <div className="rj-ev-list__placeholder__empty-element"></div>
            </>
        )
    }
}